import { getElColorPrimary } from '@/utils/theme-color'

export enum ServiceStatus {
  /** 待使用 */
  noUse = 1,
  /** 使用中 */
  using = 2,
  /** 已完成 */
  completed = 3,
  /** 试用中 前端枚举 */
  trying = 10,
}

export const ServiceStatusLabel = {
  /** 待使用 */
  1: '待使用',
  /** 使用中 */
  2: '使用中',
  /** 已完成 */
  3: '已完成',
  /** 试用中 前端枚举 */
  10: '试用中',
}

export const ServiceStatusColor = {
  /** 待使用 */
  1: 'var(--cm-color-text-secondary)',
  /** 使用中 */
  2: '#07C3A1', /* dm-keep：使用中语义青绿 */
  /** 已完成 */
  3: 'var(--cm-color-text-secondary)',
  /** 试用中 前端枚举 */
  10: getElColorPrimary(),
}

export const ServiceStatusIcon = {
  /** 待使用 */
  1: 'views/dashboard/service/_images/no-use-marker',
  /** 使用中 */
  2: 'views/dashboard/service/_images/using-marker',
  /** 已完成 */
  3: 'views/dashboard/service/_images/no-use-marker',
  /** 试用中 前端枚举 */
  10: 'views/dashboard/service/_images/trying-market',
}

